const DEFAULT_PUBLIC_SITE_URL = 'https://ame.ua'

export const SHORT_LINK_PATH_PREFIX = '/go'

/**
 * Public storefront base URL for short links (not cp.ame.ua).
 * Override via `.env`: REACT_APP_PUBLIC_SITE_URL=https://ame.ua
 */

export const getPublicSiteUrl = () => {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_URL?.trim()

  if (fromEnv) {
    return fromEnv.replace(/\/$/, '')
  }

  return DEFAULT_PUBLIC_SITE_URL
}

export default getPublicSiteUrl
